/*
 * module.js - The description of the module.
 */

Fundu.Pages.Account = (function($) {

    // Properties
    ///////////////////////////
    var _loanInvestments = false;
    var _overdueLoanInvestments = false;

    var _loanInvestmentsInfoCircle = false;
    var _loanInvestmentsBreakdownContent = false;

    // Private Methods
    ///////////////////////////
    var selectElements = function() {
        _loanInvestments = $("#loan-investments").text();
        _overdueLoanInvestments = $("#overdue-loan-investments").text();

        _loanInvestmentsInfoCircle = $("#loan-investments-info-circle");
    };

    var checkElements = function() {

    };

    var initializeComponents = function() {
        _loanInvestmentsBreakdownContent = getLoanInvestmentsBreakdownContent();

        _loanInvestmentsInfoCircle.on('click', function() {
            showLoanInvestmentsBreakdown();
        });

        $(".owl-carousel.loan.card.list").owlCarousel({
            loop: false,
            responsiveClass: true,
            touchDrag: true,
            dots: true,
            autoheight: true,
            navText: [
                Msg("common.actions.previous"),
                Msg("common.actions.next"),
                Msg("common.actions.first"),
                Msg("common.actions.last")
            ],

            responsive:{
                0:{
                    items: 1,
                    nav: true,
                    center: true
                },
                768:{
                    items: 2,
                    nav: true,
                    center: false
                },
                1200:{
                    items: 4,
                    nav: true,
                    center: false
                }
            }
        });

        $("#profile-selector").owlCarousel({
            center: false,
            loop: false,
            responsiveClass: false,
            touchDrag: true,
            dots: true,
            autoheight: false,
            nav: false,
            autoWidth: false,
            responsive:{
                0:{
                    items: 3,
                    stagePadding: 10,
                },
                768:{
                    items: 4,
                    stagePadding: 30,
                },
                1200:{
                    items: 6,
                    stagePadding: 60,
                }
            }
        });
    };

    var getLoanInvestmentsBreakdownContent = function () {
      var loans = {
        "msg": "common.account.portfolio.investments.loans",
        "value": _loanInvestments
      };

      var overdueLoans = {
        "msg": "common.account.portfolio.investments.overdue_loans",
        "value": _overdueLoanInvestments
      };

      var lineBreak = undefined;

      var total = {
        "msg": "common.account.portfolio.investments.total",
        "value": _loanInvestments
      };

      var valuesToShow = [loans, overdueLoans, lineBreak, total];

      var elements = valuesToShow.map(function (data) {
        if (data && data.msg && data.value) {
          return $("<div class='row'></div>").append(
            [
              $("<div class='col-sm-5 col-xs-7'></div>").append(Fundu.Helpers.Notify.translate(data.msg)),
              $("<div class='col-sm-4 col-xs-4 text-right'></div>").append("<b>" + data.value + " €</b>"),
              $("<div></div>")
            ]
          )
        } else {
          return $("<br>")
        }
      });

      return $("<div></div>").append(elements);
    };

    var showLoanInvestmentsBreakdown = function() {
      Fundu.Helpers.Modal.setModalContent("common.account.portfolio.investments.header", _loanInvestmentsBreakdownContent);
      Fundu.Helpers.Modal.showModal();
    };

    // Init
    ///////////////////////////
    var initialize = function() {
        selectElements();
        initializeComponents();

        Fundu.Components.Diagram.init();
        Fundu.Components.Table.init();

        return $.Deferred().resolve(true);
    };

    var finalize = function() {

    };

    // Reveal public methods
    return {
        init: initialize,
        finalize: finalize
    }

})(jQuery);
